import { Injectable } from "@angular/core";
/* import { XlatPipe } from "@amt/i18n/xlat-pipe";
import { ICustomInputNumber } from "@functionalComponents/controls/custom-input-number/custom-input-number.component";
import { ICustomInputText } from "@functionalComponents/controls/custom-input/custom-input.component";
import { ICustomMultiselect } from "@functionalComponents/controls/custom-multiselect/custom-multiselect.component";
import { ICustomTextarea } from "@functionalComponents/controls/custom-textarea/custom-textarea.component";
import { IGridValue } from "@functionalComponents/selectable-grid/selectable-grid.component"; */

@Injectable({
  providedIn: "root",
})
export class UtilityService {
/*   constructor(protected xlatPipe: XlatPipe) {}
  public operationalSections: IGridValue[] = [
    {
      label: this.setText("endOfMonth.personnel"),
      canSave: true,
      complete: false,
      id: "endOfMonth.personnel",
      apiBased: true,
    },
    {
      label: this.setText("siteDetails.kpi"),
      canSave: true,
      complete: false,
      id: "endOfMonth.kpis",
      url: "",
      apiBased: true,
    },
    {
      label: this.setText("endOfMonth.qualifications"),
      canSave: true,
      complete: false,
      id: "endOfMonth.qualifications",
      apiBased: true,
    },
    {
      label: this.setText("endOfMonth.trainingDelivered"),
      canSave: true,
      complete: false,
      id: "endOfMonth.trainingDelivered",
      apiBased: true,
    },
    {
      label: this.setText("endOfMonth.trainingReceived"),
      canSave: false,
      complete: false,
      id: "endOfMonth.trainingReceived",
      url: "getEndOfMonthTrainingReceived",
      apiBased: false,
    },
    {
      label: this.setText("endOfMonth.engineering"),
      canSave: true,
      complete: false,
      id: "endOfMonth.engineering",
      apiBased: true,
    },
    {
      label: this.setText("endOfMonth.continuousImprovement"),
      canSave: false,
      complete: false,
      id: "endOfMonth.continuousImprovement",
      url: "getEndOfMonthContinuousImprovement",
      apiBased: false,
    },
  ];
  public setText(text: string, paramNumber?: number) {
    return `${this.xlatPipe.transform(text,paramNumber)}`;
  } */
  public getFileNameFromHeader(header) {
    if (!header) {
      return null;
    }
    var result = header.split(";")[1].trim().split("=")[1];
    return result.replace(/"/g, "");
  };
  /* resetTextInput(componentConfig: ICustomInputText) {
    var tempConfig = componentConfig;
    tempConfig.value = "";
    return { ...tempConfig };
  }
  resetNumberInput(componentConfig: ICustomInputNumber) {
    var tempConfig = componentConfig;
    tempConfig.value = null;
    return { ...tempConfig };
  }
  resetMultipleSelect(componentConfig: ICustomMultiselect) {
    var tempConfig = componentConfig;
    tempConfig.selectedValues = [];
    return { ...tempConfig };
  }
  resetTextArea(componentConfig: ICustomTextarea) {
    var tempConfig = componentConfig;
    var el = document.getElementById(tempConfig.id) as HTMLElement;
    if (el) {
      var inbox = el.children[0] as HTMLTextAreaElement;
      inbox.value = "";
    }
    tempConfig.value = "";
    return { ...tempConfig };
  }
  resetDatepickerInput(componentConfig: any) {
    var tempComponentConfig = componentConfig;
    tempComponentConfig.inputValue = null;
    componentConfig = { ...tempComponentConfig };
    return componentConfig;
  } */
}
